export function AxiosRequestInterceptor(config) {
      // Extract cookies from `document.cookie`
      const cookies = document.cookie.split(';').reduce((acc, cookie) => {
        const [key, value] = cookie.split('=').map((item) => item.trim());
        acc[key] = value;
        return acc;
      }, {});
      // AppCookieService prefixes cookie names with appvar (e.g. "avadmin_accessToken")
      const token = cookies['avadmin_accessToken'] || cookies['accessToken'];
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
}
  